import { render, staticRenderFns } from "./TabEight.vue?vue&type=template&id=11a6e7ea&scoped=true&"
import script from "./TabEight.vue?vue&type=script&lang=js&"
export * from "./TabEight.vue?vue&type=script&lang=js&"
import style0 from "./TabEight.vue?vue&type=style&index=0&id=11a6e7ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a6e7ea",
  null
  
)

export default component.exports